import { render, staticRenderFns } from "./TaskDetailDrawer.vue?vue&type=template&id=452017f6&scoped=true&"
import script from "./TaskDetailDrawer.vue?vue&type=script&lang=js&"
export * from "./TaskDetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailDrawer.vue?vue&type=style&index=0&id=452017f6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452017f6",
  null
  
)

export default component.exports